import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'

const RedactedText = ({ lineWidth }) => { // eslint-disable-line
  return (
    <Box
      css={{
        height: '16px',
        width: lineWidth,
        marginBottom: '6px',
        backgroundColor: 'color-background-interactive',
        borderRadius: '10px',
        opacity: '0.7'
      }}
    />
  )
}

RedactedText.PropTypes = {
  lineWidth: PropTypes.string,
}

const REDACTED = 'redacted'

const withFreemiumText = ({ prop }) => Component => {
  const WithFreemiumText = props => {
    return (
      props[prop] === REDACTED
        ? (
          <Box>
            <RedactedText lineWidth='100%' />
            <RedactedText lineWidth='70%' />
          </Box>
          )
        : <Component {...props} />
    )
  }
  WithFreemiumText.displayName = Component.displayName
    ? `WithFreemiumText(${Component.displayName})`
    : 'WithFreemiumText'

  return WithFreemiumText
}

export default withFreemiumText
